export default "__VITE_ASSET__0823ea4e__"